import { RegistryList } from '@frontend/wam-sales-demo-service';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function SalesDemoRegistry() {
  return (
    <Page
      title='Sales Demo - Registry'
      breadcrumbs={[{ label: 'Global Settings' }, { label: 'Sales Demo' }, { label: 'Registry' }]}
      maxWidth='100%'
    >
      <Container>
        <RegistryList />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/sales-demo-registry',
  component: SalesDemoRegistry,
  type: 'auth',
  locationRequired: false,
});
